import CarouselItem from '../../../../common/js/CarouselItem'

export default class Camp extends CarouselItem {
  constructor($el, map) {
    super($el)

    this.$animationContainer = this.$el.querySelector('.animation-container')

    this.map = map
    this.map.ready.then(next => {
      this.next = next
    })

    const canvas = this.$animationContainer.querySelector('.canvas')
    const canvas1 = this.$animationContainer.querySelector('.canvas1')

    const domOverlayContainer = this.$animationContainer.querySelector('.dom-overlay-container')
    this.map.init(this.$animationContainer, canvas, canvas1, domOverlayContainer)

    this.$stepTriggers = Array.from(this.$el.querySelectorAll('[data-animation-step]'))

    let observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && this.active) {
          this.next()
          observer.unobserve(entry.target)
        }
      })
    }, {
      threshold: 0
    })

    this.$stepTriggers.forEach($trigger => {
      observer.observe($trigger)
    })
  }


  activate() {
    this.active = true;
    this.$el.classList.add('active')
    this.map.pause(false)
  }

  deactivate() {
    this.active = false;
    this.$el.classList.remove('active')
    this.map.pause()
  }
}
